import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingPage } from '../loading-page';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { IconName } from '../../../shared/interfaces/icon-picker.model';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import ReductionActionService from '../../../shared/services/reduction-action/reduction-action.service';
import { IReductionActionForReportPeriod } from '../../../shared/services/reduction-action/reduction-action.model';
import { ReductionActionPlan } from '../../presentation-components/reduction-components/reduction-action-plan';
import { FlagRemovalActionDialog } from '../../dialogs/reduction/flag-removal-action-dialog';
import { useIsReportPeriodLocked } from '../../../hooks/use-is-report-period-locked';

export const ReductionFlagRemovalsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isReportPeriodLocked = useIsReportPeriodLocked();
  const reductionActionService = new ReductionActionService();

  const [organisationReductionActions, setOrganisationReductionActions] = useState<IReductionActionForReportPeriod[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState<string>();
  const [order, setOrder] = useState<'asc' | 'desc'>();
  const [isLoading, setIsLoading] = useState(true);
  const [isDialogOpen, setDialogOpen] = useState(false);

  const selectedActionId = useMemo(() => searchParams.get('actionId') || undefined, [searchParams]);

  const getAllActionsForOrganisation = () => {
    reductionActionService
      .getAllReductionActionsForReportPeriodWithPagination('organisationWide=true&actionType=flag_removal', inputPage, perPage, orderBy, order)
      .then((response) => {
        setIsLoading(false);
        setOrganisationReductionActions(response.rows);
        setTotalRecords(response.count);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setOrganisationReductionActions([]);
        setTotalRecords(0);
      });
  };

  useEffect(() => {
    getAllActionsForOrganisation();
  }, [inputPage, perPage, orderBy, order]);

  useEffect(() => {
    if (selectedActionId) {
      setDialogOpen(true);
    }
  }, [selectedActionId]);

  return (
    <PageOuterContainer>
      <PageHeading
        title='FLAG Removals'
        hasTabs={false}
        includeActionButton={true}
        actionButtonIcon={IconName.Add}
        actionButtonHandler={() => setDialogOpen(true)}
        actionButtonText='Add FLAG Removal Action'
        hideShowActionButton={isReportPeriodLocked === true}
        actionButtonVariant='text'
      />
      <LoadingPage pageReady={!isLoading}>
        <ReductionActionPlan
          actionType='flag_removal'
          setOrder={setOrder}
          setOrderBy={setOrderBy}
          reductionActions={organisationReductionActions}
          getAllActionsForOrganisation={getAllActionsForOrganisation}
          inputPage={inputPage}
          setInputPage={setInputPage}
          totalRecords={totalRecords}
          perPage={perPage}
          setPerPage={setPerPage}
        />
      </LoadingPage>
      {isDialogOpen && (
        <FlagRemovalActionDialog
          open={isDialogOpen}
          actionId={selectedActionId}
          onClose={() => {
            setDialogOpen(false);
            navigate('/reduction-plan/flag');
          }}
          onSaved={getAllActionsForOrganisation}
        />
      )}
    </PageOuterContainer>
  );
};
